import type { ExpenseClaim, ExpenseFile, ExpenseLine, ExpenseSummary } from '@dxtech/shared';
import { call } from './library.js';

// 경비지출 API
export interface ExpenseInput { id?: string; title: string; project: string; tripId?: string; lines: ExpenseLine[]; }

async function saveBlob(path: string, fileName: string): Promise<void> {
  const blob = await (await call(path)).blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = fileName; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const expenseApi = {
  list: async (scope: 'mine' | 'all') => (await (await call(`/expenses?scope=${scope}`)).json()) as { items: ExpenseSummary[] },
  get: async (id: string) => (await (await call(`/expenses/${id}`)).json()) as { claim: ExpenseClaim; files: ExpenseFile[] },
  save: async (input: ExpenseInput) => (await (await call('/expenses', input)).json()) as { claim: ExpenseClaim },
  remove: (id: string) => call(`/expenses/${id}/delete`, {}),
  act: (id: string, action: 'submit' | 'withdraw' | 'approve' | 'reject' | 'pay', reason?: string) =>
    call(`/expenses/${id}/${action}`, reason ? { reason } : {}),
  upload: (id: string, fileName: string, contentBase64: string, contentType: string) =>
    call(`/expenses/${id}/files`, { fileName, contentBase64, contentType }),
  removeFile: (id: string, fileId: string) => call(`/expenses/${id}/files/${encodeURIComponent(fileId)}/delete`, {}),
  download: (id: string, f: ExpenseFile) => saveBlob(`/expenses/${id}/files/${encodeURIComponent(f.id)}`, f.name),
  exportCsv: (month: string) => saveBlob(`/expenses/export?month=${month}`, `경비지출_${month}.csv`),
};
